/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues, typeFirst } from '../runtime';
import type { BackgroundJobExecutionState } from './BackgroundJobExecutionState';
import {
    BackgroundJobExecutionStateFromJSON,
    BackgroundJobExecutionStateFromJSONTyped,
    BackgroundJobExecutionStateToJSON,
} from './BackgroundJobExecutionState';

/**
 * 
 * @export
 * @interface DatabaseChangeJobInfoDto
 */
export interface DatabaseChangeJobInfoDto {
    /**
     * 
     * @type {string}
     * @memberof DatabaseChangeJobInfoDto
     */
    readonly id?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DatabaseChangeJobInfoDto
     */
    readonly errorMessage?: string | null;
    /**
     * 
     * @type {BackgroundJobExecutionState}
     * @memberof DatabaseChangeJobInfoDto
     */
    state?: BackgroundJobExecutionState;
    /**
     * 
     * @type {boolean}
     * @memberof DatabaseChangeJobInfoDto
     */
    readonly rebootRequired?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DatabaseChangeJobInfoDto
     */
    readonly rebootIsDone?: boolean;
    /**
     * 
     * @type {string}
     * @memberof DatabaseChangeJobInfoDto
     */
    $type?: DatabaseChangeJobInfoDtoTypeEnum;
}


/**
 * @export
 */
export const DatabaseChangeJobInfoDtoTypeEnum = {
    PtwPtw100AppZeroApplicationSharedInstallDatabaseDatabaseChangeJobInfoDtoPtwPtw100AppZeroApplicationShared: 'Ptw.Ptw100.AppZero.Application.Shared.Install.Database.DatabaseChangeJobInfoDto, Ptw.Ptw100.AppZero.Application.Shared'
} as const;
export type DatabaseChangeJobInfoDtoTypeEnum = typeof DatabaseChangeJobInfoDtoTypeEnum[keyof typeof DatabaseChangeJobInfoDtoTypeEnum];


/**
 * Check if a given object implements the DatabaseChangeJobInfoDto interface.
 */
export function instanceOfDatabaseChangeJobInfoDto(value?: unknown): value is DatabaseChangeJobInfoDto {
    return !!value && typeof value === 'object' && "$type" in value && value.$type === Object.values(DatabaseChangeJobInfoDtoTypeEnum)[0];
}

export function DatabaseChangeJobInfoDtoFromJSON(json: any): DatabaseChangeJobInfoDto {
    return DatabaseChangeJobInfoDtoFromJSONTyped(json, false);
}

export function DatabaseChangeJobInfoDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): DatabaseChangeJobInfoDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'errorMessage': !exists(json, 'errorMessage') ? undefined : json['errorMessage'],
        'state': !exists(json, 'state') ? undefined : BackgroundJobExecutionStateFromJSON(json['state']),
        'rebootRequired': !exists(json, 'rebootRequired') ? undefined : json['rebootRequired'],
        'rebootIsDone': !exists(json, 'rebootIsDone') ? undefined : json['rebootIsDone'],
        '$type': !exists(json, '$type') ? undefined : json['$type'],
    };
}

export function DatabaseChangeJobInfoDtoToJSON(value?: DatabaseChangeJobInfoDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return typeFirst({
        
        'state': BackgroundJobExecutionStateToJSON(value.state),
        '$type': value.$type,
    });
}

